import React from 'react';
import { MdWarning, MdClose } from 'react-icons/md';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Conferma', cancelText = 'Annulla', type = 'danger' }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-dialog-overlay" onClick={onClose}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-dialog-header">
          <div className="confirm-dialog-icon-wrapper">
            <MdWarning className={`confirm-dialog-icon ${type}`} />
          </div>
          <button
            className="confirm-dialog-close"
            onClick={onClose}
            title="Chiudi"
          >
            <MdClose />
          </button>
        </div>
        
        <div className="confirm-dialog-content">
          {title && (
            <h3 className="confirm-dialog-title">{title}</h3>
          )}
          <p className="confirm-dialog-message">{message}</p>
        </div>

        <div className="confirm-dialog-actions">
          <button
            className="confirm-dialog-btn confirm-dialog-btn-cancel"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className={`confirm-dialog-btn confirm-dialog-btn-confirm confirm-dialog-btn-${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;


